import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Tooltip } from 'react-tooltip';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from 'store/ducks';
import store from 'store';

import { Column, Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import RadioInput from 'components/RadioInput';
import OrdersTable from 'components/Table/Orders';
import { ordersModelOpenProtocol, billedFilter, } from 'components/Table/Orders/models';
import ProductsTable from 'components/Table/Products';
import { Visibility } from 'components/Visibility';
import { openProtocolProductModel } from 'components/Table/Products/models';
import OpenProtocolOrderItems from 'components/OpenProtocolOrderItems';
import Validator from 'components/Validator';
import toast from 'components/Toast/dispatch';
import { Button } from 'components/Button';
import Table from 'components/Table';
import { CTETable } from 'components/Table/CTEs/Listing';
import { cteModelTableOpenProtocol } from 'components/Table/CTEs/Listing/models';
import { cteInvoicingModelTableOpenProtocol } from 'components/Table/CTEs/Invoicing/model';
import { CTEInvoicingTable } from 'components/Table/CTEs/Invoicing';

import { IOrders } from 'models/Order';
import { IProducts } from 'models/Product';
import { EnumUserType } from 'models/User';
import { ICustomer } from 'models/Customer';
import { EnumCategories, EnumReason, ILegalPersonType } from 'models/Ticket';
import { ICustomerRole } from 'models/CustomerRole';
import { IDomainSetting } from 'models/DomainSetting';
import { CTeInvoiceState, CTeState } from 'models/CTEs';

import iconPlusGreen from 'img/icon-plus-green.svg';
import iconPlusGrey from 'img/icon-plus-grey.svg';
import iconMinus from 'img/icon-minus.svg';

import { IsInLimitDate } from 'utils/Date';
import { lockedProduct } from 'utils/OpenProtocol';
import { In } from 'utils/Patterns/Specification';

import DomainSettingService from 'services/domainSetting.service';
import { useCustomerDataContext } from 'contexts/OpenProtocol/CustomerData/CustomerDataContext';
import { useOpenProtocolContext } from 'contexts/OpenProtocol';

import './styles.scss';

const LinkType: React.FC<any> = (props) => {

  const {
    linkType,
    setLinkType,
    disableProduct,
    disableOrder,
    protocolCategory,
    returnType,
    brands,
    isEditing,
    ticketReason,
    dispatchLinkTypeData,
    legalPerson
  } = props;

  const { user } = store.getState();

  const { disableCte } = useOpenProtocolContext();
  const { customerProtocol } = useCustomerDataContext();


  const customer = useSelector((state: { customer: ICustomer; }) => state.customer);
  const order = useSelector((state: RootState) => state.openProtocolData?.order);
  const products = useSelector((state: RootState) => state.openProtocolData?.products);
  const cte_s = useSelector((state: RootState) => state.openProtocolData?.cte);
  const cteInvoice = useSelector((state: RootState) => state.openProtocolData?.cteInvoice);

  const [brandsNotBlocked, setBrandsNotBlocked] = useState<Array<IDomainSetting>>([]);
  const [checkActivateOrderButton, setCheckActivateOrderButton] = useState<boolean>(true);

  const [showCteInvoice, setShowCteInvoice] = useState<boolean>(false);

  const orderRef = useRef<IOrders>();

  const dispatch = useDispatch();

  const [tabFilter,] = useState({
    or: [
      {
        and: billedFilter,
      },
    ],
  });

  const _domainSettingService = new DomainSettingService();

  useEffect(() => {
    _domainSettingService
      .get(undefined, undefined, 'value asc', {
        and: [
          { identifier: { eq: 'BrandsNotBlocked' } },
          { enabled: { eq: true } },
        ],
      })
      .then((result: any) => {
        if (result && result.data) {
          const _brandsNotBlocked: Array<IDomainSetting> = result.data;

          setBrandsNotBlocked(_brandsNotBlocked);
        }
      });
  }, []);

  useEffect(() => {
    enableCteInvoice();
  }, [customerProtocol, legalPerson, customer, user]);

  const customOrderModel = () => {
    const customOrderModel = ordersModelOpenProtocol;

    customOrderModel[2] = {
      ...customOrderModel[2],
      size: 100,
      Component: (data: any) => (
        <Text className="color-blue-gray" size={12}>
          {data.items?.length} {orderRef?.current?.items?.length && ` / ${orderRef?.current?.items.length}`}
        </Text>
      ),
    };

    return customOrderModel;
  };

  function selectLinkType(link: string) {
    if (link === linkType) {
      setLinkType('');
      resetOrderAndProducts();
      return;
    }

    resetOrderAndProducts();
    setLinkType(link);
  }

  const resetOrderAndProducts = useCallback(() => {
    dispatch({ type: 'RESET_OPEN_PROTOCOL_DATA' });
    orderRef.current = undefined;
  }, [dispatch]);

  useEffect(() => {
    if (!isEditing) {
      (!checkActivateOrderButton || protocolCategory === '1') && setLinkType('');
      resetOrderAndProducts();
    }
  }, [protocolCategory, resetOrderAndProducts, returnType]);

  function onSelectOrder(data: any) {
    dispatchLinkTypeData("SET_OPEN_PROTOCOL_ORDER", { ...data, items: [] });
    orderRef.current = data;
  }

  function handleSelectAndRemoveData(data: any) {
    if (linkType === "PRODUCT")
      dispatchLinkTypeData("SET_OPEN_PROTOCOL_PRODUCTS", [data]);

    if (linkType === "CTE")
      dispatchLinkTypeData("SET_OPEN_PROTOCOL_CTE", [data]);

    if (linkType === "CTE_INVOICE")
      dispatchLinkTypeData("SET_OPEN_PROTOCOL_CTE_INVOICE", [data]);
  }

  function lockedOrderButtonMessage() {
    if (user?.userType === 'customer') {
      return 'Este pedido passou o prazo de entrega para abertura de uma solicitação de devolução. Favor entrar em contato com o SAC';
    }
    return 'Este pedido passou o prazo de entrega para abertura de uma solicitação de devolução. Favor avaliar com o time comercial';
  }

  function lockedOrderButtonModal() {
    if (user?.userType === 'customer') {
      toast.error('Este pedido passou o prazo de entrega para abertura de uma solicitação de devolução. Favor entrar em contato com o SAC');
    } else {
      toast.error('Este pedido passou o prazo de entrega para abertura de uma solicitação de devolução. Favor avaliar com o time comercial');
    }
  }

  function renderOrderButton(data: IOrders) {
    let enableOrderButton = true;
    let noBlock;

    const brandsIds = brandsNotBlocked[0].value?.split(',');
    if (brandsIds) {
      noBlock = new In(brandsIds);
    }

    if (protocolCategory === EnumCategories.DEVOLUCAO && data?.status?.toUpperCase() === 'ENTREGUE') {
      if (!IsInLimitDate(data.invoiceDeliveryDate, 7)) {
        enableOrderButton = false;
      }
    }

    if (protocolCategory === EnumCategories.DEVOLUCAO && data?.status?.toUpperCase() !== 'ENTREGUE'
      && !noBlock?.isSatisfiedBy(brands)) {
      if (!IsInLimitDate(data.billingDate.toString(), 11))
        enableOrderButton = false;
    }

    if (user?.profileType?.includes('CC_SAC_SERVICE') ||
      user?.profileType?.includes('CC_LOGISTIC_SERVICE') ||
      user?.profileType?.includes('INTERNAL_COMMERCIAL')) {
      enableOrderButton = true;
    }

    setCheckActivateOrderButton(enableOrderButton);

    return (
      <Button
        id="expand-order"
        tooltip={enableOrderButton ? undefined : lockedOrderButtonMessage()}
        className="p-0"
        onClick={() => {
          if (!enableOrderButton) {
            lockedOrderButtonModal();
            return;
          } else {
            order?.id === data.id
              ? onSelectOrder(undefined)
              : onSelectOrder(data);
          }

        }}
      >
        <img
          src={enableOrderButton ? iconPlusGreen : iconPlusGrey}
          alt=""
          style={{ height: 13, width: 13 }}
        />
      </Button>
    );
  }

  const handleCheckedProduct = (data: any) => {
    if (!lockedProduct(data.locked, protocolCategory, returnType, user))
      handleSelectAndRemoveData(data);

    return null;
  };

  const reactTooltipId = `ReactTooltip${Math.random().toString().split('.')[1]}`;
  const msgBlockedProduct = 'Devoluções de produtos tipo vacina devem ser solicitadas para a área responsável';

  const categoriesBlocked = ['1', '7', 'RECLAMAÇÃO TÉCNICA', 'DEVOLUÇÃO'];

  const enableCteInvoice = () => {
    if (user?.userType === EnumUserType.CUSTOMER) {
      const customerSelected = user?.customersRoles?.find((c: ICustomerRole) =>
        user?.selectedCustomerId?.includes(c.customerId!));

      if (customerProtocol?.useElectronicBillLading || customerSelected?.useElectronicBillLading) {
        setShowCteInvoice(true);
        return;
      }
    }

    if (user?.userType === EnumUserType.EMPLOYEE) {
      if (legalPerson === ILegalPersonType.JURIDICAL_PERSON &&
        (customerProtocol?.useElectronicBillLading || customer?.useElectronicBillLading)) {
        setShowCteInvoice(true);
        return;
      }
    };

    setShowCteInvoice(false);

  };

  const validateDisableInputs = () => {
    if (categoriesBlocked.includes(protocolCategory)) {
      return true;
    }

    return false;
  };

  return (
    <>
      <Column className="mt-5">
        <Text className="mb-2 color-blue-gray" size={12}>
          Tipo de Vínculo
        </Text>
        <Row className="flex-md-column">

          <Visibility visible={!disableOrder}>
            <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
              <RadioInput
                id="ORDER"
                onClick={() => selectLinkType('ORDER')}
                checked={linkType === 'ORDER' && !disableOrder}
                classname={isEditing && validateDisableInputs() && 'cursor-not-allowed'}
                disabled={isEditing && validateDisableInputs() ? true : disableOrder}
              >
                <Text className="color-blue-gray">Pedido</Text>
              </RadioInput>
            </Row>
          </Visibility>

          <Visibility visible={!disableProduct}>
            <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
              <RadioInput
                id="PRODUCT"
                onClick={() => selectLinkType('PRODUCT')}
                checked={linkType === 'PRODUCT' && !disableProduct}
                classname={isEditing && validateDisableInputs() && 'cursor-not-allowed'}
                disabled={isEditing && validateDisableInputs() ? true : disableProduct}
              >
                <Text className="color-blue-gray">Produto</Text>
              </RadioInput>
            </Row>
          </Visibility>

          <Visibility visible={!disableCte}>
            <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
              <RadioInput
                id="CTE"
                onClick={() => selectLinkType('CTE')}
                checked={linkType === 'CTE'}
                classname={isEditing && categoriesBlocked.includes(protocolCategory) && 'cursor-not-allowed'}
                disabled={isEditing && categoriesBlocked.includes(protocolCategory) ? true : disableCte}
              >
                <Text className="color-blue-gray">CTE</Text>
              </RadioInput>
            </Row>
          </Visibility>

          <Visibility visible={showCteInvoice}>
            <Row className="w-md-100 mt-md-2" style={{ width: 200 }}>
              <RadioInput
                id="CTE_INVOICE"
                onClick={() => selectLinkType('CTE_INVOICE')}
                checked={linkType === 'CTE_INVOICE'}
                classname={isEditing && categoriesBlocked.includes(protocolCategory) && 'cursor-not-allowed'}
                disabled={isEditing && categoriesBlocked.includes(protocolCategory) || !showCteInvoice}
              >
                <Text className="color-blue-gray">Fatura</Text>
              </RadioInput>
            </Row>
          </Visibility>
        </Row>
      </Column>

      {linkType === 'ORDER' && !order ? (
        <Validator value={order} name="Pedido" required>
          <OrdersTable
            trackingKey="Grid Pedidos"
            tabFilter={tabFilter}
            showFilter
            tableSearchClassName="px-0 pb-3"
            customProps={{
              showOrderTrackingHistory: false,
              showOrderDownloadButtons: false,
            }}
            model={[
              {
                label: '',
                Component: (data: IOrders) => renderOrderButton(data),
                size: 40,
                maxSize: 40,
              },
              ...ordersModelOpenProtocol,
            ]}
          />
        </Validator>
      ) : linkType === 'ORDER' && !disableOrder ? (
        <>
          <Table
            trackingKey="Grid Pedidos"
            className="mt-3"
            data={[order]}
            model={[
              {
                label: '',
                Component: () => (
                  <Button
                    className={`p-0 ${isEditing && validateDisableInputs() && 'cursor-not-allowed'}`}
                    onClick={() => isEditing && validateDisableInputs() ? null : resetOrderAndProducts()}
                    id="retract-order"
                  >
                    <img
                      src={iconMinus}
                      alt=""
                      style={{ height: 13, width: 13, cursor: isEditing && validateDisableInputs() ? 'not-allowed' : 'inherit' }}
                    />
                  </Button>
                ),
                size: 40,
                maxSize: 40,
              },
              ...customOrderModel(),
            ]}
          />
          <OpenProtocolOrderItems
            protocolCategory={protocolCategory}
            isEditing={isEditing}
            ticketReason={ticketReason}
            returnType={returnType}
          />
        </>
      ) : linkType === 'PRODUCT' && !disableProduct ? (
        <ProductsTable
          model={[
            {
              label: '',
              Component: (data: IProducts) => (
                <>
                  <input
                    type="radio"
                    data-tooltip-content={lockedProduct(data.locked, protocolCategory, returnType, user) ?
                      msgBlockedProduct : undefined
                    }
                    data-tooltip-id={reactTooltipId}
                    data-tooltip-place={'top'}
                    name="products"
                    id={`select-product-${data.id}`}
                    onClick={() => handleCheckedProduct(data)}
                    value={data.id}
                    checked={
                      !lockedProduct(data.locked, protocolCategory, returnType, user) ?
                        products?.find((item: any) => item.id === data.id)
                        : false
                    }
                    defaultChecked={
                      !lockedProduct(data.locked, protocolCategory, returnType, user) ?
                        products?.find((item: any) => item.id === data.id) : false
                    }
                    className={lockedProduct(data.locked, protocolCategory, returnType, user) ? 'disabled radio-product' : 'radio-product'}
                  />
                  {lockedProduct(data.locked, protocolCategory, returnType, user) &&
                    <Tooltip id={reactTooltipId} variant="light" />
                  }
                </>
              ),
              size: 40,
              maxSize: 40,
            },
            ...openProtocolProductModel,
          ]}
          showCards={false}
          className="pb-3 pb-md-0"
          isEditing={isEditing}
          protocolCategory={protocolCategory}
        />
      ) : null}


      <Visibility visible={linkType === 'CTE' && !disableCte}>
        <Validator value={cte_s} name="Ct-e" required>
          <CTETable
            trackingKey="Grid CTEs"
            model={[
              {
                label: '',
                Component: (data: CTeState) => (
                  <>
                    <input
                      type="radio"
                      data-tooltip-id={reactTooltipId}
                      data-tooltip-place="top"
                      name="cte_s"
                      onClick={() => handleSelectAndRemoveData(data)}
                      value={data.id}
                      defaultChecked={cte_s?.find((item: any) => item.id === data.id)}
                      className="radio-product"
                    />
                  </>
                ),
                size: 40,
                maxSize: 40,
              },
              ...cteModelTableOpenProtocol(),
            ]}
            tableSearchClassName="px-0 pb-3"
            showFastFilters={false}
            isEditing={isEditing}
          />
        </Validator>
      </Visibility>

      <Visibility visible={linkType === 'CTE_INVOICE' && showCteInvoice}>
        <Validator value={cteInvoice} name="CteInvoice" required>
          <CTEInvoicingTable
            trackingKey="Grid Faturamento CTEs"
            model={[
              {
                label: '',
                Component: (data: CTeInvoiceState) => (
                  <input
                    type="radio"
                    data-tooltip-id={reactTooltipId}
                    data-tooltip-place="top"
                    name="cte_invoice"
                    onClick={() => handleSelectAndRemoveData(data)}
                    value={data.id}
                    defaultChecked={cteInvoice?.find((item: CTeInvoiceState) => item.id === data.id)}
                    className="radio-product"
                  />
                ),
                size: 40,
                maxSize: 40,
              },
              ...cteInvoicingModelTableOpenProtocol(),
            ]}
            tableSearchClassName="px-0 pb-3"
            isEditing={isEditing}
          />
        </Validator>
      </Visibility>
    </>
  );
};

export default LinkType;
